var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanFeature1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_87978",
    "data-name": "Group 87978",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.381,
    height: 24.69,
    viewBox: "0 0 26.381 24.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25570",
    "data-name": "Rectangle 25570",
    width: 26.381,
    height: 24.69,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87977",
    "data-name": "Group 87977",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308205",
    "data-name": "Path 308205",
    d: "M4.918,20.947h-2.7v2.128a1.348,1.348,0,0,0,2.7,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308206",
    "data-name": "Path 308206",
    d: "M3.236,23.075V20.947H2.221v2.128a1.349,1.349,0,0,0,1.856,1.249,1.349,1.349,0,0,1-.841-1.249",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308207",
    "data-name": "Path 308207",
    d: "M24.745,24.423H21.657V22.685h3.088a.565.565,0,0,1,.564.564v.61a.564.564,0,0,1-.564.564",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308208",
    "data-name": "Path 308208",
    d: "M24.745,22.685H21.657v.733h3.088a.563.563,0,0,1,.56.5.605.605,0,0,0,0-.061v-.61a.564.564,0,0,0-.564-.564",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308209",
    "data-name": "Path 308209",
    d: "M19.245,17.312H7.135v-4.54A2.135,2.135,0,0,1,9.27,10.637h7.84a2.135,2.135,0,0,1,2.135,2.135Z",
    transform: "translate(0 0)",
    fill: "#ff97bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308210",
    "data-name": "Path 308210",
    d: "M19.245,17.312H7.135v-4.54A2.135,2.135,0,0,1,9.27,10.637h7.84a2.135,2.135,0,0,1,2.135,2.135Z",
    transform: "translate(0 0)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308211",
    "data-name": "Path 308211",
    d: "M10.342,10.637H9.271a2.136,2.136,0,0,0-2.136,2.135v4.54H8.207v-4.54a2.135,2.135,0,0,1,2.135-2.135",
    transform: "translate(0 0)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308212",
    "data-name": "Path 308212",
    d: "M19.245,17.312H18.2V13.729a.524.524,0,1,1,1.048,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308213",
    "data-name": "Path 308213",
    d: "M14.037,12.7l-.249,1.007H12.593L12.344,12.7l.846-.692Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308214",
    "data-name": "Path 308214",
    d: "M13.077,12.925l.618-.5-.5-.412-.847.692.249,1.007h.677Z",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308215",
    "data-name": "Path 308215",
    d: "M13.788,13.707h-1.2l-.617,3.754,1.208,1.4,1.221-1.4Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308216",
    "data-name": "Path 308216",
    d: "M12.765,17.348l.6-3.641h-.77l-.617,3.754,1.208,1.405.445-.513Z",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308217",
    "data-name": "Path 308217",
    d: "M10.047,10.637h1.647l1.5,1.371L11.8,13.144Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308218",
    "data-name": "Path 308218",
    d: "M12.632,12.419l.559-.41-1.5-1.372H10.677Z",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308219",
    "data-name": "Path 308219",
    d: "M16.334,10.637H14.687l-1.5,1.371,1.391,1.136Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308220",
    "data-name": "Path 308220",
    d: "M13.749,12.419l-.559-.41,1.5-1.372H15.7Z",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308221",
    "data-name": "Path 308221",
    d: "M14.687,8.332H11.694v2.305l1.5,1.371,1.5-1.371Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308222",
    "data-name": "Path 308222",
    d: "M13.149,9.558a2.89,2.89,0,0,1-2.887-2.893V3.275h5.789l-.015,3.4a2.89,2.89,0,0,1-2.887,2.883",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308223",
    "data-name": "Path 308223",
    d: "M11.333,6.665V3.275H10.262v3.39a2.889,2.889,0,0,0,2.887,2.893,2.854,2.854,0,0,0,.535-.051,2.891,2.891,0,0,1-2.351-2.842",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308224",
    "data-name": "Path 308224",
    d: "M18.9,24.423H7.483l-1.536-8.19H20.435Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308225",
    "data-name": "Path 308225",
    d: "M5.947,16.233l1.536,8.19H8.5l-1.535-8.19Z",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308226",
    "data-name": "Path 308226",
    d: "M13.191,19.047a1.3,1.3,0,1,1-1.3,1.3,1.3,1.3,0,0,1,1.3-1.3",
    transform: "translate(0 0)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308227",
    "data-name": "Path 308227",
    d: "M13.021,20.343a1.3,1.3,0,0,1,.734-1.168,1.3,1.3,0,1,0,0,2.336,1.3,1.3,0,0,1-.734-1.168",
    transform: "translate(0 0)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308228",
    "data-name": "Path 308228",
    d: "M13.191,21.92a1.578,1.578,0,1,1,1.579-1.578,1.58,1.58,0,0,1-1.579,1.578m0-2.592a1.015,1.015,0,1,0,1.015,1.014,1.016,1.016,0,0,0-1.015-1.014",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308229",
    "data-name": "Path 308229",
    d: "M19.133,22.589a.395.395,0,1,1-.395.395.4.4,0,0,1,.395-.395",
    transform: "translate(0 0)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308230",
    "data-name": "Path 308230",
    d: "M26.1,24.128h-.558a.828.828,0,0,0,.05-.282v-.61a.847.847,0,0,0-.846-.844h-.113V20.938a.281.281,0,0,0-.281-.282H21.262a.846.846,0,0,0-.845.845v.609a.846.846,0,0,0,.845.845h.113v1.173H7.716L6.287,16.511H20.094l-.952,5.074a.282.282,0,0,0,.554.1l1.015-5.408a.283.283,0,0,0-.277-.333h-.907V12.771a2.417,2.417,0,0,0-2.416-2.413H14.969V9.268a3.171,3.171,0,0,0,1.3-2.04,1.718,1.718,0,0,0,.613-.333,2.589,2.589,0,0,0,.8-2.044c.292-3.97-3.192-5.258-5.5-4.742A1.525,1.525,0,0,0,10.71,1.368c-1.437.052-2.1,2.087-2.016,3.065,0,2.013.882,2.569,1.324,2.722a3.181,3.181,0,0,0,1.394,2.167v1.036H9.27a2.417,2.417,0,0,0-2.416,2.413v3.177H5.947a.283.283,0,0,0-.277.333l1.473,7.847H4.8a1.62,1.62,0,0,0,.4-1.065V20.937a.281.281,0,0,0-.281-.281h-2.7a.281.281,0,0,0-.282.281v.418H1.523a.734.734,0,0,0-.733.732V22.8a.734.734,0,0,0,.733.732H2.01a1.615,1.615,0,0,0,.328.592H.282a.282.282,0,1,0,0,.564H26.1a.282.282,0,1,0,0-.563ZM13.721,12.805l-.154.619h-.754l-.153-.619.53-.433Zm-1.745-2.29v-.9A3.166,3.166,0,0,0,14.4,9.584v.931L13.19,11.627Zm.856,3.474h.717l.321,1.959H12.51Zm4.279-3.068a1.853,1.853,0,0,1,1.852,1.85v3.177H14.442l-.365-2.234L14.2,13.2l.2.163a.284.284,0,0,0,.409-.057l1.669-2.384Zm-1.318,0-1.269,1.813-.9-.737L14.8,10.921ZM10.544,6.678V5.018a5.984,5.984,0,0,0,3.393-1.207,2.955,2.955,0,0,0,1.832,1.094l-.017,1.846a2.6,2.6,0,0,1-5.208-.073m1.041,4.243L12.76,12l-.9.737-1.269-1.813Zm-4.167,1.85a1.853,1.853,0,0,1,1.852-1.85H9.9l1.669,2.384a.284.284,0,0,0,.409.057l.2-.163.127.514-.365,2.235H7.418ZM1.94,22.972H1.523a.169.169,0,0,1-.169-.169v-.716a.169.169,0,0,1,.169-.169H1.94Zm2.7.091a1.067,1.067,0,0,1-2.133,0V21.219H4.636Zm20.391.783a.282.282,0,0,1-.282.282H21.939V22.955h2.806a.281.281,0,0,1,.282.281Z",
    transform: "translate(0 0)",
    fill: "#515255"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanFeature1);
export default __webpack_public_path__ + "static/media/Plan_Feature_1.933bab5d438c81b88c126f2bf9a68862.svg";
export { ForwardRef as ReactComponent };